import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { MdEdit } from "react-icons/md";
import {
  useCreateExpenseItemMutation,
  useUpdateExpenseItemMutation,
} from "../../redux/features/expenseItem/expenseItemApi";
import { toast } from "react-toastify";

const AddExpenseItem = ({ expenseItem }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [name, setName] = useState("");

  const [createExpenseItem, { isLoading: creatingLoading }] =
    useCreateExpenseItemMutation();
  const [updateExpenseItem, { isLoading: updateLoading }] =
    useUpdateExpenseItemMutation();

  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    setName("")
    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};
    if (!name) newErrors.name = "Expense Item name is requried";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      let response;

      if (expenseItem) {
        response = await updateExpenseItem({
          name,
          id: expenseItem?._id,
        }).unwrap();
      } else {
        response = await createExpenseItem(name).unwrap();
      }

      if (response?.success) {
        toast.success(response?.message);
        handleClose()
      }
    } catch (error) {
      toast.error(error?.data?.message);
    }
  };

  useEffect(() => {
    if (isOpen && expenseItem) {
      setName(expenseItem?.name);
    }
  }, [expenseItem, isOpen]);
  return (
    <div>
      {expenseItem ? (
        <div
          onClick={handleOpen}
          className="bg-[#0D868C] text-center text-white p-1 rounded-lg cursor-pointer"
        >
          <MdEdit className="lg:size-6 size-5" />
        </div>
      ) : (
        <button
          onClick={handleOpen}
          className="fixed bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
        >
          <FaPlus className="md:text-xl text-[1rem]" />
        </button>
      )}

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[650px] w-[90%] mx-auto p-10 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-4 mb-8">
              <h1 className="md:text-[1.75rem] text-[1rem] font-bold text-[#0D868C]">
                {expenseItem ? "Update Expense Item" : "Create Expense Item"}
              </h1>
              <button type="button"  disabled={creatingLoading || updateLoading} onClick={handleClose}>
                <FiX className="md:size-8 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-6 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Expense Name
                </label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Write the expense reason"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.name && (
                  <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                )}
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  disabled={creatingLoading || updateLoading}
                  className="text-white bg-[#0D868C] md:w-[50%] w-full py-3 rounded-full disabled:opacity-50 disabled:cursor-not-allowed outline-none uppercase font-normal text-[1rem]"
                >
                  {expenseItem ? "Update Expense Item" : "Create Expense Item"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddExpenseItem;
